"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultResizableImageState = void 0;
const element_vir_1 = require("element-vir");
exports.defaultResizableImageState = {
    imageData: (0, element_vir_1.asyncState)(),
    shouldVerticallyCenter: false,
    settled: false,
    /**
     * Storing the full frame HTMLl string allows the frame to preserve its state across DOM
     * detachments and re-attachments.
     */
    frameFullHtml: undefined,
};
